<template lang="pug">
div
  slot
  slot(name="footer")
    .modal-footer(:class="{ disabled }")
      button.btn.btn-danger.pull-left(
        v-if="showDeleteButton"
        type="button"
        @click.stop="onClick('delete', $event)"
      )
        | {{ deleteButtonLabel }}

      button.btn.btn-default(
        type="button"
        :class="{ 'pull-left': !showDeleteButton }"
        @click.stop="onClick('close', $event)"
      )
        | Cancel

      button.btn.btn-default(
        v-if="showBackButton"
        type="button"
        @click.stop="onClick('previous', $event)"
      )
        | Back

      button.btn.hs-btn-transparent-primary.save-exit-link(
        v-if="saveAndClose"
        :disabled="saveExitDisabled"
        @click.stop="onClick('saveAndExit', $event)"
      )
        | {{ saveButtonText }}

      button.btn.btn-primary(
        v-if="!isLastStep"
        :disabled="nextButtonDisabled"
        type="button"
        data-testid="wizard-next-button"
        @click.stop="onClick('next', $event)"
      )
        | {{ nextButtonText }}

      button.btn.btn-primary(
        v-if="isLastStep"
        :disabled="saveButtonDisabled"
        type="button"
        data-testid="wizard-save-button"
        @click.stop="onClick('input', $event)"
      )
        | {{ saveButtonText }}
</template>

<script>
export default {
  name: 'AppWizardStep',
  props: {
    saveButtonDisabled: {
      type: Boolean,
      default: false,
    },
    saveExitDisabled: {
      type: Boolean,
      default: false,
    },
    deleteButtonLabel: {
      type: String,
      default: 'Delete',
    },
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
    isLastStep: {
      type: Boolean,
      default: false,
    },
    saveAndClose: {
      type: Boolean,
      default: false,
    },
    saveButtonText: {
      type: String,
      default: 'Save',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    nextButtonDisabled: {
      type: Boolean,
      default: false,
    },
    nextButtonText: {
      type: String,
      default: 'Next',
    },
  },
  // Declare emitted events so Vue 3 does NOT also bind them as native fallthrough listeners on the
  // root <div>. Without this, `@input="save"` (the Save button emit) ALSO catches the native `input`
  // event bubbling up from any <input>/checkbox inside the step — e.g. the "Automatically add new
  // members" checkbox — firing save() and creating the record unexpectedly.
  emits: ['delete', 'close', 'previous', 'saveAndExit', 'next', 'input'],
  methods: {
    onClick(action, e) {
      this.$emit(action, e);
    },
  },
};
</script>
